import {useGraphql} from "@/core/graphql/service";
import vorderSubmitMutation from "@/gql/gen/mutation/vorderSubmitMutation";
import {useOrdersStore} from "@/modules/shop/store/orders";
import {useVorderApi} from "@/modules/shop/store/vorder-api";
import {defineStore, storeToRefs} from "pinia";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";
import {sleep} from "@/core/util/sleep";
import {useUtmStore} from "@/modules/marketing/store/utm";

const STORE_NAME = 'vorder-submit'

export const useVorderSubmit = defineStore(STORE_NAME, () => {

    const {useMutation, responseSelection} = useGraphql();
    const vorderApi = useVorderApi()
    const ordersStore = useOrdersStore()
    const basketStore = useBasketStore()
    const vorderState = useVorderState()

    const basketRulesStore = useBasketRulesStore()

    const {ensureBenefitType} = basketRulesStore

    const {
        attrs,
        coupon,
        vorderId
    } = storeToRefs(vorderState)

    const submitRequest = useMutation(vorderSubmitMutation({
        payload: {
            order: {
                __fragment: 'OrderFields',
            },
            orderId: true,
            orderUrl: true,
            newVorderId: true,
            activeOrders: {
                __fragment: 'OrderFields'
            },
            vorder: {
                __fragment: 'VorderCurrentFields'
            }
        },
        ...responseSelection()
    }))

    async function submitToServer() {

        const input = vorderApi.vorderInput

        const res = await submitRequest.mutate({
            order: input
        })

        if (res.success) {

            if (res.payload?.vorder) {
                vorderApi.updateVorderFromServer(res.payload?.vorder)
            }

            if (res.payload?.newVorderId) {
                vorderId.value = res.payload?.newVorderId
            }

            if (res.payload?.activeOrders) {
                ordersStore.setActiveOrders(res.payload.activeOrders)

                setTimeout(() => {
                    ordersStore.activeOrdersRequest.query({}, {refetch: true})
                }, 100)

            } else {
                ordersStore.activeOrdersRequest.query({}, {refetch: true})
            }

            basketStore.fillBasket([])

            attrs.value.DATE = null
            attrs.value.TIME = null
            attrs.value.COUPON_ID = null
            attrs.value.PRIZE_ID = null
            attrs.value.WITH_OPERATOR = false

            coupon.value = null

            useUtmStore().reset()

            ensureBenefitType()
        }

        return res
        // alert('SUBMI1111T')
    }

    return {
        submitToServer,
        submitRequest
    }
})

